export default __webpack_public_path__ + "84d4ffffa61294baea9bc06ecbed36b9.png";